cv.PostsRowEmptyView = Marionette.LayoutView.extend({
  className: 'row-empty',
  template: cv.Templates['posts/empty'],

  events : {
  },

  templateHelpers: function(){
    return {
    };
  },

  initialize: function(options){
    console.log('PostsRowEmptyView initialized');
  },

  onShow: function(){
  }
});
